import React, { useEffect, useState } from 'react';
import api from '../../api/client';
import '../docs/SchemaDoc.css';

/**
 * Docs → VERA Metrics: human-readable view of the same recipes injected into
 * VERA's system prompt and enforced by metric_* tools.
 */
export default function VeraMetricsDoc() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/docs/vera-metric-recipes');
        if (!cancelled) setData(res.data);
      } catch (e) {
        if (!cancelled) setError(e?.response?.data?.message || e.message || 'Failed to load recipes');
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="sd-page">
      <header className="sd-header">
        <div>
          <h1>VERA Metric Recipes</h1>
          <p className="sd-subtitle">
            These are the canonical KPI definitions VERA must follow (same source as
            the system prompt and the <code>metric_*</code> tools). They keep login
            volume / distinct users aligned with Data Trends.
          </p>
        </div>
      </header>

      {error && <p className="sd-subtitle" style={{ color: '#b91c1c' }}>{error}</p>}
      {!data && !error && <p className="sd-subtitle">Loading…</p>}

      {data && (
        <>
          <p className="sd-subtitle" style={{ marginBottom: '1.5rem' }}>
            {data.note}
          </p>

          <section className="sd-table" style={{ marginBottom: '1.5rem' }}>
            <h2 className="sd-table-title">Login counter fields</h2>
            <p className="sd-subtitle" style={{ margin: 0 }}>
              {(data.loginCounterFields || []).map((f) => (
                <code key={f} style={{ marginRight: '0.5rem' }}>{f}</code>
              ))}
            </p>
          </section>

          {(data.recipes || []).map((r) => (
            <section key={r.id} className="sd-table" id={`recipe-${r.id}`}>
              <h2 className="sd-table-title">{r.name}</h2>
              <dl className="vm-dl">
                <div><dt>Id</dt><dd><code>{r.id}</code></dd></div>
                <div><dt>DataType</dt><dd>{r.dataType}</dd></div>
                <div><dt>Grain</dt><dd>{r.grain}</dd></div>
                <div><dt>Definition</dt><dd>{r.definition}</dd></div>
                <div><dt>Never</dt><dd>{r.neverDo}</dd></div>
                {r.preferredTool && (
                  <div><dt>Preferred tool</dt><dd><code>{r.preferredTool}</code></dd></div>
                )}
                {r.exampleSql && (
                  <div>
                    <dt>Example SQL</dt>
                    <dd><pre className="vm-sql">{r.exampleSql}</pre></dd>
                  </div>
                )}
              </dl>
            </section>
          ))}
        </>
      )}

      <style>{`
        .vm-dl { margin: 0.75rem 0 0; display: grid; gap: 0.65rem; }
        .vm-dl > div { display: grid; grid-template-columns: 9rem 1fr; gap: 0.75rem; }
        .vm-dl dt { margin: 0; color: #64748b; font-weight: 600; font-size: 0.85rem; }
        .vm-dl dd { margin: 0; color: #0f172a; line-height: 1.45; }
        .vm-sql {
          margin: 0; padding: 0.75rem 1rem; background: #f8fafc; border: 1px solid #e2e8f0;
          border-radius: 8px; overflow-x: auto; font-size: 0.8rem; white-space: pre-wrap;
        }
      `}</style>
    </div>
  );
}
